import React from 'react';
import { Divider } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { getKeyOnly, mergeStrings} from './utils/utils';


const getClasses = ({ smaller, small, medium, large}) => {
    return mergeStrings(
        getKeyOnly(smaller, 'smaller'),
        getKeyOnly(small, 'small'),
        getKeyOnly(medium, 'medium'),
        getKeyOnly(large, 'large'),
    )
};

export const CustomDivider = ({ smaller, small, medium, large, ...rest }) => {
    const classes = getClasses({ smaller, small, medium, large });
    return <Divider {...rest} className={classes} />;
};


CustomDivider.propTypes = {
    smaller: PropTypes.bool,
    small: PropTypes.bool,
    medium: PropTypes.bool,
    large: PropTypes.bool,
};
